/** method type */
export var MethodType;
(function (MethodType) {
    MethodType["UNDEFINED"] = "UNDEFINED";
    MethodType["ONLINE"] = "ONLINE";
    MethodType["FACE_TO_FACE"] = "FACE_TO_FACE";
})(MethodType || (MethodType = {}));
/** enumeration with all possible domains */
export var Domain;
(function (Domain) {
    Domain["UNDEFINED"] = "UNDEFINED";
    Domain["ORDER"] = "ORDER";
    Domain["CREDIT_CARD"] = "CREDIT_CARD";
    Domain["SAVED_CREDIT_CARD"] = "SAVED_CREDIT_CARD";
    Domain["PAYMENT_METHOD"] = "PAYMENT_METHOD";
})(Domain || (Domain = {}));
/**
 * What kind of payment the buyer wants to perform: A one-time payment, a recurring payment, or an authorize
 * payment - authorize is when the provider reserves the funds from the user’s credit card, but doesn’t actually
 * charge them. This is usually done for ‘booking’ style flows, where the hotel reserves the booking amount but only
 * charges it when the guest arrives. Authorize flow is not fully supported by Cashier yet, work in progress.
 */
export var ChargeIntent;
(function (ChargeIntent) {
    ChargeIntent["UNDEFINED"] = "UNDEFINED";
    ChargeIntent["SALE"] = "SALE";
    ChargeIntent["RECURRING"] = "RECURRING";
})(ChargeIntent || (ChargeIntent = {}));
export var SavePaymentMethodDisplayOption;
(function (SavePaymentMethodDisplayOption) {
    SavePaymentMethodDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    SavePaymentMethodDisplayOption["SHOW_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_DISCLAIMER"] = "SHOW_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_DISCLAIMER"] = "SHOW_MERCHANT_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_VISITOR_DISCLAIMER"] = "SHOW_VISITOR_DISCLAIMER";
})(SavePaymentMethodDisplayOption || (SavePaymentMethodDisplayOption = {}));
export var AllowMerchantUseDisplayOption;
(function (AllowMerchantUseDisplayOption) {
    AllowMerchantUseDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    AllowMerchantUseDisplayOption["SHOW_ALLOW_MERCHANT_USE_CHECKBOX"] = "SHOW_ALLOW_MERCHANT_USE_CHECKBOX";
})(AllowMerchantUseDisplayOption || (AllowMerchantUseDisplayOption = {}));
export var CreditCardNetwork;
(function (CreditCardNetwork) {
    CreditCardNetwork["UNDEFINED_NETWORK"] = "UNDEFINED_NETWORK";
    CreditCardNetwork["AMEX"] = "AMEX";
    CreditCardNetwork["CARTES_BANCAIRES"] = "CARTES_BANCAIRES";
    CreditCardNetwork["CHINA_UNION_PAY"] = "CHINA_UNION_PAY";
    CreditCardNetwork["DISCOVER"] = "DISCOVER";
    CreditCardNetwork["EFTPOS"] = "EFTPOS";
    CreditCardNetwork["ELECTRON"] = "ELECTRON";
    CreditCardNetwork["ELO"] = "ELO";
    CreditCardNetwork["INTERAC"] = "INTERAC";
    CreditCardNetwork["JCB"] = "JCB";
    CreditCardNetwork["MADA"] = "MADA";
    CreditCardNetwork["MAESTRO"] = "MAESTRO";
    CreditCardNetwork["MASTER_CARD"] = "MASTER_CARD";
    CreditCardNetwork["PRIVATE_LABEL"] = "PRIVATE_LABEL";
    CreditCardNetwork["VISA"] = "VISA";
    CreditCardNetwork["VPAY"] = "VPAY";
    CreditCardNetwork["BANCONTACT_CARD"] = "BANCONTACT_CARD";
})(CreditCardNetwork || (CreditCardNetwork = {}));
export var MerchantCapability;
(function (MerchantCapability) {
    MerchantCapability["UNDEFINED_CAPABILITY"] = "UNDEFINED_CAPABILITY";
    MerchantCapability["SUPPORTS_3DS"] = "SUPPORTS_3DS";
    MerchantCapability["SUPPORTS_EMV"] = "SUPPORTS_EMV";
    MerchantCapability["SUPPORTS_CREDIT"] = "SUPPORTS_CREDIT";
    MerchantCapability["SUPPORTS_DEBIT"] = "SUPPORTS_DEBIT";
})(MerchantCapability || (MerchantCapability = {}));
export var PanType;
(function (PanType) {
    PanType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    /** PAN_ONLY */
    PanType["FPAN"] = "FPAN";
    /** CRYPTOGRAM_3DS */
    PanType["DPAN"] = "DPAN";
})(PanType || (PanType = {}));
//# sourceMappingURL=types.impl.js.map